import { PageCommercialDepositAccountAgreement } from './CommercialDepositAccountAgreement';
import { PageSweepProgramDepositPlacementCustodialAgreements } from './SweepProgramDepositPlacementCustodialAgreements';

export const LEGAL = {
  CommercialDepositAccountAgreement: PageCommercialDepositAccountAgreement,
  SweepProgramDepositPlacementCustodialAgreements: PageSweepProgramDepositPlacementCustodialAgreements,
} as const;
